module.exports = __webpack_public_path__ + "static/media/bitcoin4.58c6f602.png";